import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PatientDemographicsConstants } from '../store/patientDemographics.constants'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getPatientDemographicsSelector } from '../selectors'
import { getServiceIdSelector } from '../../user/selectors'
import { setSavePatientDemographicsResponse } from '../store/patientDemographics.actions'
import { IPatientDemographicsState } from '../store/patientDemographics.types'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { setHasPatient } from '../../patientInformation/store/patientInformation.actions'
import { getTexasWristbandReportTypeConfigSelector } from '../../configurations/selectors'
import { ITexasWristbandReportTypeConfig } from '../../configurations/store/configurations.types'

export function* savePatientDemographics() {
  const patientDemographics: IPatientDemographicsState = yield select(getPatientDemographicsSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  const texasWristbandReportTypeConfig: ITexasWristbandReportTypeConfig | null = yield select(
    getTexasWristbandReportTypeConfigSelector
  )
  if (pcrID) {
    const newPhoneDetails = patientDemographics?.phoneDetails?.filter(
      (phone) => phone.number !== '' || phone.type !== null
    )
    const newEmailDetails = patientDemographics?.emailDetails?.filter(
      (email) => email.address !== '' || email.type !== null
    )
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      patient: {
        ...pcrDoc.patient,
        patientDemographics: {
          ...patientDemographics,
          phoneDetails: newPhoneDetails,
          emailDetails: newEmailDetails,
          // always stamp current report type metadata so server never needs to query tb_nemsis3_reporttype
          ...(texasWristbandReportTypeConfig && {
            texasWristbandReportTypeId: texasWristbandReportTypeConfig.id,
            texasWristbandNemsis3: texasWristbandReportTypeConfig.nemsis3,
          }),
        },
      },
    }

    if (pcrDocUpdated?.patient?.patientDemographics?.citizenship == null) {
      pcrDocUpdated.patient.patientDemographics.citizenship = { id: 0, name: '' }
    }

    try {
      yield put(setHasPatient(true))
      const response: string = yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      yield put(setSavePatientDemographicsResponse(response))
    } catch (e) {
      yield put(throwPcrException(`savePatientDemographics() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* savePatientDemographicsSaga() {
  yield takeLatest(
    [PatientDemographicsConstants.SAVE_PATIENT_DEMOGRAPHICS],
    performWithMutexHOG,
    savePatientDemographics
  )
}
